// @flow
import {
    KICKED_OUT,
    conferenceLeft,
} from '../base/conference';
import { MiddlewareRegistry } from '../base/redux';

import { notifyKickedOut } from './actions';

MiddlewareRegistry.register(store => next => action => {
    const result = next(action);

    switch (action?.type) {
        case KICKED_OUT: {
            const { dispatch } = store;

            dispatch(notifyKickedOut(
                action.participant,
                () => {
                    dispatch(conferenceLeft(action.conference));
                }
            ));

            break;
        }
    }

    return result;
});